module.exports = __webpack_public_path__ + "static/media/verification.36d6718a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/verification.svg
// module id = 2283
// module chunks = 0